import {CardActions, CardContent, styled} from '@mui/material';

const StyledCardActions = styled(CardActions)`
	padding: 0 16px 16px;
	justify-content: flex-end;
`;

const StyledCardContent = styled(CardContent)`
	display: flex;
	gap: 8px;
	align-items: start;
	justify-content: space-between;
`;

export {StyledCardActions, StyledCardContent};
